// this file is automatically generated by git.revision.js script
export const versions = { revision: 'fc58e5741e' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'fc58e5741e';
